import type { NahledyudajuPppVypisSeznamPppParams } from '@gov-nx/api';

type PPPSeznamTyp = NahledyudajuPppVypisSeznamPppParams['typSeznamu'];
type PPPStav = Exclude<NahledyudajuPppVypisSeznamPppParams['stav'], undefined>;

const PPP_SEZNAM_TYP_MAP: Record<PPPSeznamTyp, true> = {
	AKTUALNI: true,
	HISTORIE: true,
};

const PPP_STAV_MAP: Record<PPPStav, true> = {
	VSE: true,
	PRIJATO: true,
	SCHVALENO: true,
	ODESLANO_K_DOPRACOVANI: true,
	ODESLANO_SPRAVCI: true,
	ZAMITNUTO: true,
	UKONCENO: true,
};

export const isSeznamTyp = (value: string): value is PPPSeznamTyp =>
	value in PPP_SEZNAM_TYP_MAP;

export const isSeznamStav = (value: string): value is PPPStav =>
	value in PPP_STAV_MAP;
